export default "__VITE_ASSET__BJHPqAJD__"